import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import CookieConsent from 'react-cookie-consent';

import DigitalNav from './pages/Solutions/DigitalNav';
import DigitalFooter from './pages/Solutions/DigitalFooter';

import Digital from './pages/Solutions/Digital';
import Automatisation from './pages/Solutions/Automatisation';
import CreationSiteWeb from './pages/Services/CreationSiteWeb';
import ReseauxSociaux from './pages/Services/ReseauxSociaux';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import PaymentSuccess from './pages/PaymentSuccess/PaymentSuccess';
import PrivacyPolicy from './pages/Legal/PrivacyPolicy';
import TermsOfService from './pages/Legal/TermsOfService';
import MentionsLegales from './pages/Legal/MentionsLegales';
import NotFound from './pages/NotFound/NotFound';

const DigitalLayout = () => (
  <>
    <DigitalNav />
    <Outlet />
    <DigitalFooter />
    <CookieConsent
      location="bottom"
      buttonText="J'accepte"
      declineButtonText="Refuser"
      enableDeclineButton
      style={{ background: '#080808', borderTop: '1px solid rgba(255,255,255,0.06)', fontFamily: 'DM Sans, sans-serif', fontSize: '0.85rem', alignItems: 'center', padding: '1rem 2rem' }}
      buttonStyle={{ background: '#C9A84C', color: '#050507', fontSize: '0.8rem', fontWeight: '600', padding: '0.6rem 1.5rem', borderRadius: '4px', border: 'none', cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '1px' }}
      declineButtonStyle={{ background: 'transparent', color: 'rgba(255,255,255,0.3)', fontSize: '0.8rem', padding: '0.6rem 1rem', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '4px', cursor: 'pointer' }}
      expires={365}
    >
      Nous utilisons des cookies pour améliorer votre expérience. En continuant, vous acceptez notre{' '}
      <a href="/politique-confidentialite" style={{ color: '#C9A84C', textDecoration: 'underline' }}>politique de confidentialité</a>.
    </CookieConsent>
  </>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route element={<DigitalLayout />}>
            <Route path="/" element={<Digital />} />
            <Route path="/services/creation-site-web" element={<CreationSiteWeb />} />
            <Route path="/services/reseaux-sociaux" element={<ReseauxSociaux />} />
            <Route path="/solutions/automatisation" element={<Automatisation />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/paiement-success" element={<PaymentSuccess />} />
            <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/conditions-utilisation" element={<TermsOfService />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
